import { render, staticRenderFns } from "./AiCourse.vue?vue&type=template&id=13daa32a&scoped=true"
import script from "./AiCourse.vue?vue&type=script&lang=js"
export * from "./AiCourse.vue?vue&type=script&lang=js"
import style0 from "./AiCourse.vue?vue&type=style&index=0&id=13daa32a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13daa32a",
  null
  
)

export default component.exports